import { captureException } from './error';
import { CloudFunctionRequestError } from '@asurion-core/frontend-utils/lib/ErrorsModule/ErrorsModule';
import { showErrorPopup } from 'components/popups/ErrorPopup/ErrorPopup';
import get from 'lodash/get';

// Reimporting the module into itself in order to allow for unit testing inner function showErrorMessage https://stackoverflow.com/questions/51269431/jest-mock-inner-function/55193363#55193363
import * as errorPopupUtil from './errorPopupUtil';

import * as SimplrErrors from '@asurion-core/typescript-utils/SimplrErrors';

const MESSAGES = {
  DEFAULT_ERROR_MESSAGE: 'An error occurred while performing the action, please try again.',
  SESSION_IS_INVALID: 'Your session is invalid. Please log off the platform and log back in.',
};

export const showTimerPopupError = (errorObj, skipSentry = false) => {
  if (!skipSentry) {
    captureException(errorObj.message);
  }

  showErrorPopup(errorObj.message, errorObj.header, null, errorObj.expirationTime);
};

/** Show a known error message
 * @param  {string} message
 * @param skipSentry
 * @param showLogout
 * @returns {function}
 */
export const showErrorMessage = (message = MESSAGES.DEFAULT_ERROR_MESSAGE, skipSentry = false, showLogout) => {
  if (typeof message !== 'string') {
    captureException(message);
    message = MESSAGES.DEFAULT_ERROR_MESSAGE;
  } else if (!skipSentry) {
    captureException(message);
  }

  showErrorPopup(message, null, showLogout);
};

/** Show an error generated by the Express backend
 * @param  {object} error
 * @param {string} message
 * @returns {function}
 */
export const showExpressError = (error, message) => {
  captureException(error);
  let friendlyMessage = message ? message : MESSAGES.DEFAULT_ERROR_MESSAGE;

  if (error.status === 423) {
    return errorPopupUtil.showErrorMessage(`Processing of your request failed. Please try again shortly.`, true);
  } else if (error.status === 429) {
    return errorPopupUtil.showErrorMessage(
      'Processing of your request failed. Please try again in a few minutes.',
      true
    );
  } else if (error.status === 401 && get(error, 'response.body.code') === 401) {
    captureException(new Error(`[SimplrWeb] Logout triggered: showExpressError 401, status=${error.status}`));
    return errorPopupUtil.showErrorMessage(MESSAGES.SESSION_IS_INVALID, true, true);
  }

  return errorPopupUtil.showErrorMessage(friendlyMessage, true);
};

export const showSimplrError = (simplrError) => {
  if (simplrError.message === 'Case currently locked by another user') {
    return errorPopupUtil.showErrorMessage(
      'This ticket is currently locked by another user. Please try again later.',
      true
    );
  }

  if (simplrError.message.includes("This person isn't available right now.")) {
    return errorPopupUtil.showErrorMessage("This person isn't available right now.", true);
  }

  if (simplrError.code === SimplrErrors.Codes.AUTHENTICATION_ERROR) {
    captureException(
      new Error(`[SimplrWeb] Logout triggered: showSimplrError AUTHENTICATION_ERROR, message=${simplrError.message}`)
    );
    return errorPopupUtil.showErrorMessage(MESSAGES.SESSION_IS_INVALID, true, true);
  }

  return errorPopupUtil.showErrorMessage(simplrError.message);
};

export const showError = (error) => {
  if (SimplrErrors.SimplrError.isSimplrError(error)) {
    return errorPopupUtil.showSimplrError(error);
  }

  const responseError = error?.response;

  if (error instanceof CloudFunctionRequestError && SimplrErrors.SimplrError.isSimplrError(responseError)) {
    return errorPopupUtil.showSimplrError(responseError);
  }

  return errorPopupUtil.showExpressError(error);
};
